import { render, staticRenderFns } from "./lazyblock_donation.vue?vue&type=template&id=291a7172&scoped=true"
import script from "./lazyblock_donation.vue?vue&type=script&lang=js"
export * from "./lazyblock_donation.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_donation.vue?vue&type=style&index=0&id=291a7172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291a7172",
  null
  
)

export default component.exports